<app-label-inflator #labelCalculator hidden class="product-label-container" [labelComponentInterface]="rowViewModel">
</app-label-inflator>

<div
  #sectionItem
  class="product-container new-product-container"
  id="product-container-m{{ menu.id }}-s{{ sectionIndex }}-i{{ itemIndex }}"
  [ngClass]="[
    rowViewModel | sectionRowViewModelBasicMethod: 'getReadableStrainType' | lowercase,
    menu | productMenuBasicMethod: 'getProductWrapperClass' : odd
  ]"
  [style.border-color]="viewModel.sectionBorderColor$ | async">
  <div #subContainer class="new-product-sub-container">
    <app-column-wrapper
      *ngIf="viewModel.imageColumnConfig$ | async as assetColConfig"
      [menu]="menu"
      [section]="section"
      [colVm]="assetColConfig"
      [rowVm]="rowViewModel"
      [locConfig]="locationConfig"
      [locationId]="locationId"
      [productStylingVm]="viewModel"
      [ignoreColConfigWidth]="true"
      [additionalClasses]="'product-column-new-badge'">
      <app-column-asset
        [menu]="menu"
        [section]="section"
        [colVm]="assetColConfig"
        [rowVm]="rowViewModel"
        [locConfig]="locationConfig"
        [locationId]="locationId"
        [productStylingVm]="viewModel"
        [reset]="reset">
      </app-column-asset>
      <div
        *ngIf="viewModel.badgeEnabled$ | async"
        class="product-column-general product-badge product-new-badge"
        [style.visibility]="section?.collapseContent ? 'collapse' : ''">
        <div *ngFor="let b of rowViewModel | allVariantBadges" class="badge new-product-badge">
          <img
            appImage
            [style.height]="'100%'"
            [style.width]="'100%'"
            [asset]="b.image"
            [reset]="reset"
            alt="badge"
            src="" />
        </div>
      </div>
    </app-column-wrapper>
    <div #productColumnsAndDesc class="new-product-columns-and-desc">
      <div
        class="new-product-columns"
        [class.odd]="odd"
        [class.even]="!odd"
        [class.first]="first"
        [class.last]="last"
        [class.force-bold-style]="viewModel.forcedRowBoldStyling$ | async"
        [class.force-italic-style]="viewModel.forcedRowItalicStyling$ | async"
        [class.has-background-color]="viewModel.rowBackgroundColor$ | async | getArrayElementAtIndex: 1"
        [ngStyle]="viewModel.productWrappingStyle$ | async"
        [style.background-color]="viewModel.rowBackgroundColor$ | async | getArrayElementAtIndex: 1"
        [style.color]="viewModel.forcedRowTextColorToDisplay$ | async"
        [style.text-decoration-color]="viewModel.forcedRowTextColor$ | async">
        <ng-container *ngFor="let colVm of viewModel.newProductColumnViewModels$ | async">
          <!--    Lay out product title column    -->
          <app-column-name
            *ngIf="colVm.columnType === Types.SectionColumnProductInfoType.ProductTitle"
            [calculationMode]="calculationMode"
            [menu]="menu"
            [section]="section"
            [colVm]="colVm"
            [allColVms]="viewModel.newProductColumnViewModels$ | async"
            [rowVm]="rowViewModel"
            [locConfig]="locationConfig"
            [locationId]="locationId"
            [productStylingVm]="viewModel"
            [reset]="reset"
            [additionalClasses]="'new-product-title-container'">
          </app-column-name>
          <!--    Lay out non-title columns    -->
          <app-column-wrapper
            [menu]="menu"
            [section]="section"
            [colVm]="colVm"
            [rowVm]="rowViewModel"
            [locConfig]="locationConfig"
            [locationId]="locationId"
            [productStylingVm]="viewModel"
            [colWidthFudgeFactor]="subContainer?.clientWidth / productColumnsAndDesc?.clientWidth">
            @if (colVm.columnType === Types.SectionColumnProductInfoType.VariantPrice) {
              <app-column-primary-price
                [menu]="menu"
                [section]="section"
                [colVm]="colVm"
                [rowVm]="rowViewModel"
                [locConfig]="locationConfig"
                [locationId]="locationId"
                [productStylingVm]="viewModel" />
            } @else if (colVm.columnType === Types.SectionColumnProductInfoType.VariantSecondaryPrice) {
              <app-column-secondary-price
                [menu]="menu"
                [section]="section"
                [colVm]="colVm"
                [rowVm]="rowViewModel"
                [locConfig]="locationConfig"
                [locationId]="locationId"
                [productStylingVm]="viewModel" />
            } @else if (colVm.columnType === Types.SectionColumnProductInfoType.QuantityAndSize) {
              <app-column-quantity-and-size
                [menu]="menu"
                [section]="section"
                [colVm]="colVm"
                [rowVm]="rowViewModel"
                [locConfig]="locationConfig"
                [locationId]="locationId"
                [productStylingVm]="viewModel" />
            } @else if (colVm.columnType === Types.SectionColumnProductInfoType.Quantity) {
              <app-column-quantity
                [menu]="menu"
                [section]="section"
                [colVm]="colVm"
                [rowVm]="rowViewModel"
                [locConfig]="locationConfig"
                [locationId]="locationId"
                [productStylingVm]="viewModel" />
            } @else if (colVm.columnType === Types.SectionColumnProductInfoType.Stock) {
              <app-column-quantity-in-stock
                [menu]="menu"
                [section]="section"
                [colVm]="colVm"
                [rowVm]="rowViewModel"
                [locConfig]="locationConfig"
                [locationId]="locationId"
                [productStylingVm]="viewModel" />
            } @else if (colVm.columnType === Types.SectionColumnProductInfoType.Size) {
              <app-column-size
                [menu]="menu"
                [section]="section"
                [colVm]="colVm"
                [rowVm]="rowViewModel"
                [locConfig]="locationConfig"
                [locationId]="locationId"
                [productStylingVm]="viewModel" />
            } @else if (colVm.columnType === Types.SectionColumnProductInfoType.StrainType) {
              <app-column-strain-type
                [menu]="menu"
                [section]="section"
                [colVm]="colVm"
                [rowVm]="rowViewModel"
                [locConfig]="locationConfig"
                [locationId]="locationId"
                [productStylingVm]="viewModel" />
            } @else if (colVm.columnType === Types.SectionColumnProductInfoType.Producer) {
              <app-column-producer
                [menu]="menu"
                [section]="section"
                [colVm]="colVm"
                [rowVm]="rowViewModel"
                [locConfig]="locationConfig"
                [locationId]="locationId"
                [productStylingVm]="viewModel" />
            } @else if (colVm.columnType === Types.SectionColumnProductInfoType.Brand) {
              <app-column-brand
                [menu]="menu"
                [section]="section"
                [colVm]="colVm"
                [rowVm]="rowViewModel"
                [locConfig]="locationConfig"
                [locationId]="locationId"
                [productStylingVm]="viewModel" />
            } @else if (colVm.columnType === Types.SectionColumnProductInfoType.Spacer) {
              <app-column-spacer
                [menu]="menu"
                [section]="section"
                [colVm]="colVm"
                [rowVm]="rowViewModel"
                [locConfig]="locationConfig"
                [locationId]="locationId"
                [productStylingVm]="viewModel" />
            } @else if (colVm.columnType === Types.SectionColumnProductInfoType.TinySpacer) {
              <app-column-tiny-spacer
                [menu]="menu"
                [section]="section"
                [colVm]="colVm"
                [rowVm]="rowViewModel"
                [locConfig]="locationConfig"
                [locationId]="locationId"
                [productStylingVm]="viewModel" />
            } @else if (colVm.columnType === Types.SectionColumnProductInfoType.Lineage) {
              <app-column-lineage
                [menu]="menu"
                [section]="section"
                [colVm]="colVm"
                [rowVm]="rowViewModel"
                [locConfig]="locationConfig"
                [locationId]="locationId"
                [productStylingVm]="viewModel" />
            } @else if (colVm.columnType === Types.SectionColumnProductInfoType.Badge) {
              <app-column-badge
                [menu]="menu"
                [section]="section"
                [colVm]="colVm"
                [rowVm]="rowViewModel"
                [locConfig]="locationConfig"
                [locationId]="locationId"
                [productStylingVm]="viewModel"
                [reset]="reset" />
            } @else if (colVm.columnType === Types.SectionColumnProductInfoType.Label) {
              <app-column-label
                [calculationMode]="calculationMode"
                [menu]="menu"
                [section]="section"
                [colVm]="colVm"
                [rowVm]="rowViewModel"
                [locConfig]="locationConfig"
                [locationId]="locationId"
                [productStylingVm]="viewModel" />
            } @else if (colVm.columnType === Types.SectionColumnProductInfoType.GradingResults) {
              <app-column-grading-results
                [menu]="menu"
                [section]="section"
                [colVm]="colVm"
                [rowVm]="rowViewModel"
                [locConfig]="locationConfig"
                [locationId]="locationId"
                [productStylingVm]="viewModel" />
            } @else if (colVm.columnType | isCannabinoidColumn) {
              <app-column-cannabinoid
                [menu]="menu"
                [section]="section"
                [colVm]="colVm"
                [rowVm]="rowViewModel"
                [locConfig]="locationConfig"
                [locationId]="locationId"
                [productStylingVm]="viewModel"
                [cannabinoidColumnType]="colVm.columnType | isCannabinoidColumn"
                [displayFormat]="colVm?.columnConfig?.dataValue" />
            } @else if (colVm.columnType | isTerpeneColumn) {
              <app-column-terpene
                [menu]="menu"
                [section]="section"
                [colVm]="colVm"
                [rowVm]="rowViewModel"
                [locConfig]="locationConfig"
                [locationId]="locationId"
                [productStylingVm]="viewModel"
                [terpeneColumnType]="colVm.columnType | isTerpeneColumn"
                [displayFormat]="colVm?.columnConfig?.dataValue" />
            } @else if (colVm.columnType | isProductTagGroupColumn) {
              <app-column-product-tag-group
                [menu]="menu"
                [section]="section"
                [colVm]="colVm"
                [rowVm]="rowViewModel"
                [locConfig]="locationConfig"
                [locationId]="locationId"
                [productStylingVm]="viewModel"
                [productTagGroupColumnType]="colVm.columnType | isProductTagGroupColumn" />
            } @else if (colVm.columnType === Types.SectionColumnProductInfoType.VariantType) {
              <app-column-variant-type
                [menu]="menu"
                [section]="section"
                [colVm]="colVm"
                [rowVm]="rowViewModel"
                [locConfig]="locationConfig"
                [locationId]="locationId"
                [productStylingVm]="viewModel" />
            }
          </app-column-wrapper>
        </ng-container>
      </div>
      <div class="new-product-desc">
        {{ rowViewModel | sectionRowViewModelBasicMethod: 'getProductDesc' }}
      </div>
    </div>
  </div>
</div>
